import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/google.png'
import _imports_1 from '@/assets/images/shape-2.png'


const _hoisted_1 = { class: "testimonial-area bg-gray5 ptb-100 position-relative z-1" }
const _hoisted_2 = { class: "container-fluid p-md-0 overflow-hidden" }
const _hoisted_3 = { class: "ps-0 list-unstyled d-flex gap-1" }
const _hoisted_4 = {
  class: "d-flex justify-content-between align-items-center google-review flex-wrap",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "300"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "container" }, [
      _createElementVNode("div", {
        class: "section-title mw-860 m-auto text-center",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("span", { class: "top-title" }, "آراء عملائنا"),
        _createElementVNode("h2", null, "ماذا يقول المشتركون عن خدماتنا؟"),
        _createElementVNode("p", null, " ثقة عملائنا هي سر نجاحنا. نسعى دائماً لتقديم أفضل تجربة بث ومتابعة بدون تقطيع. ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Swiper, {
        slidesPerView: 1,
        spaceBetween: 50,
        centeredSlides: false,
        preventClicks: true,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1440: {
            slidesPerView: 4,
          },
          1600: {
            slidesPerView: 4.5,
          },
        },
        modules: _ctx.modules,
        class: "testomonial-slide"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonials, (testimonial) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: testimonial.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(['testimonial-single-item', testimonial.className])
                }, [
                  _createElementVNode("ul", _hoisted_3, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                      return _createElementVNode("li", { key: star }, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("i", { class: "ri-star-fill" }, null, -1)
                      ]))])
                    }), 64))
                  ]),
                  _createElementVNode("h3", null, _toDisplayString(testimonial.name), 1),
                  _createElementVNode("p", null, _toDisplayString(testimonial.description), 1)
                ], 2)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"]),
      _createElementVNode("div", _hoisted_4, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "google"
          }),
          _createElementVNode("p", null, [
            _createTextVNode("التقييم العام "),
            _createElementVNode("span", null, "4.9")
          ])
        ], -1)),
        _createVNode(_component_RouterLink, {
          to: "/pricing-plan",
          class: "read-more text-grey-teal"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", null, "اشترك معنا الآن", -1),
            _createElementVNode("i", { class: "ti ti-arrow-left" }, null, -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: _imports_1,
      class: "shape shape-2",
      alt: "shape"
    }, null, -1))
  ]))
}